import { useState } from "react";
import { storage } from "../firebase.config";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import FileUpload from "./FileUpload";

function Test1ImgUpload() {
    // State to store uploaded file
    const [file, setFile] = useState("");

    // progress
    const [percent, setPercent] = useState(0);

    // Handle file upload event and update state
    function handleChange(event) {
        setFile(event.target.files[0]);
    }

    const handleUpload = () => {
        if (!file) {
            alert("Please upload an image first!");
        }

        const storageRef = ref(storage, `/eventFlyers/${file.name}`);

        // progress can be paused and resumed. It also exposes progress updates.
        // Receives the storage reference and the file to upload.
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const percent = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );

                // update progress
                setPercent(percent);
            },
            (err) => console.log(err),
            () => {
                // download url
                getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    console.log(url);
                });
            }
        );
    };

    // file upload to firebase storage location
    const [fileUrl, setFileUrl] = useState("");

    const fileStoredAt = (fileUrl) => {
        setFileUrl(fileUrl);
        console.log("file storage url received is==: ", fileUrl);
        //console.log(fileUrl);
    };

    return (
        <div>
            {/* <input type="file" onChange={handleChange} accept="/image/*" />
    <button onClick={handleUpload}>Upload to Firebase</button>
    <p>{percent} "% done"</p> */}
            <FileUpload fileStoredAt={fileStoredAt} />

        </div>
    );
}

export default Test1ImgUpload;